import React, { PropsWithChildren } from 'react';
import './swipeable-card.scss';
import { SwipeableCardButton } from './swipeable-card-button';
import {
  BUTTON_WIDTH,
  SwipeButtons,
  useSwipeableCard,
} from './use-swipeable-card';

interface SwipeableCardProps {
  leftButton?: SwipeButtons;
  rightButton?: SwipeButtons;
  className?: string;
  swipeableClassName?: string;
  isSwipeDisabled?: boolean;
}

type Props = PropsWithChildren<SwipeableCardProps>;

export const SwipeableCard: React.FC<Props> = ({
  children,
  className = '',
  swipeableClassName = '',
  leftButton,
  rightButton,
  isSwipeDisabled = false,
}) => {
  const {
    ref,
    translateX,
    resetCard,
    isDragging,
    handleTouchStart,
    handleTouchEnd,
    handleTouchMove,
  } = useSwipeableCard({ leftButton, rightButton });

  const effectiveTranslateX = isSwipeDisabled ? 0 : translateX;

  return (
    <div ref={ref} className={`swipeable-card-container ${swipeableClassName}`}>
      {!isSwipeDisabled && leftButton && (
        <div
          className="buttons-container left"
          style={{
            display: effectiveTranslateX <= 0 ? 'none' : 'flex',
            width: leftButton.buttonWidth,
          }}
        >
          <SwipeableCardButton
            onPress={() => {
              leftButton.onPress();
              resetCard();
            }}
            buttonWidth={leftButton.buttonWidth ?? BUTTON_WIDTH}
          >
            {leftButton.element}
          </SwipeableCardButton>
        </div>
      )}

      {!isSwipeDisabled && rightButton && (
        <div
          className="buttons-container right"
          style={{
            display: effectiveTranslateX >= 0 ? 'none' : 'flex',
            width: rightButton.buttonWidth,
          }}
        >
          <SwipeableCardButton
            onPress={() => {
              rightButton.onPress();
              resetCard();
            }}
            buttonWidth={rightButton.buttonWidth ?? BUTTON_WIDTH}
          >
            {rightButton.element}
          </SwipeableCardButton>
        </div>
      )}
      <div
        className={className}
        style={{
          transform: `translateX(${effectiveTranslateX}px)`,
          transition: isDragging
            ? 'none'
            : 'transform 0.25s cubic-bezier(.2,1,.3,1)',
        }}
        {...(!isSwipeDisabled && {
          onTouchStart: handleTouchStart,
          onTouchMove: handleTouchMove,
          onTouchEnd: handleTouchEnd,
        })}
        onClick={resetCard}
      >
        {children}
      </div>
    </div>
  );
};
